import { createTheme } from '@mui/material/styles';

const wwfFont = {
  fontFamily: 'WWF',
  src: `
    url('/src/assets/fonts/wwf.otf') format('opentype')
  `,
  fontWeight: 'normal',
  fontStyle: 'normal',
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#E98302',
      light: '#FFB74D',
      dark: '#F57C00',
    },
    secondary: {
      main: '#4CAF50',
      light: '#81C784',
      dark: '#388E3C',
    },
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1B1B1B',
      secondary: '#888888',
      disabled: '#CCCCCC',
    },
  },
  typography: {
    fontFamily: 'sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 700,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 700,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 700,
      fontSize: '1rem',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.43,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': [
          wwfFont,
        ],
        body: {
          '& *': {
            fontFamily: 'sans-serif',
          },
          '& [lang="en"]': {
            fontFamily: 'WWF, sans-serif',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1B1B1B',
          color: '#FFFFFF',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          background: 'none',
          border: '1px solid #e0e0e0',
          borderRadius: 1,
          boxShadow: 'none',
          height: 'calc(100vh - 220px)',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#F5F5F5',
          '& .MuiTableCell-head': {
            fontWeight: 600,
            color: '#1B1B1B',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #e0e0e0',
        },
        head: {
          fontSize: '0.875rem',
          paddingTop: 8,
          paddingBottom: 8,
        },
        body: {
          fontSize: '0.875rem',
          paddingTop: 4,
          paddingBottom: 4,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: 'none',
          whiteSpace: 'nowrap', 
          minWidth: 120, 
          color: '#fff', 
          backgroundColor: '#1B1B1B', 
          boxShadow: 'none', 
          fontWeight: 400, 
          '&:hover': { 
            boxShadow: 'none',
            backgroundColor: '#333'
          },
          transition: 'all 0.3s ease'
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          boxShadow: '0 8px 32px 0 rgba(60,60,60,0.10)',
          padding: 0,
          background: '#fff',
          minWidth: 400,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            '& .MuiListItemIcon-root': {
              color: '#E98302',
            },
            '& .MuiListItemText-primary': {
              color: '#E98302',
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#FAFAFA',
            borderRadius: 8,
            '& fieldset': {
              borderColor: '#EEEEEE',
            },
            '&:hover fieldset': {
              borderColor: '#E98302',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#888888',
          },
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
  transitions: {
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
